import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {TranslateService} from "@ngx-translate/core";
import {Observable, of} from 'rxjs';

import {ERROR_MESSAGES} from 'app/core/data/error-list.data';
import {Error} from 'app/shared/interface';
import {environment} from 'environments/environment';
import {ToastService} from './toast.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  constructor(private router: Router,
              private toastService: ToastService,
              private _translate: TranslateService
  ) {}

  static error(errorMessage, error?) {
      if (!environment.production && error) {
        console.log(error);
      }
  }

    handleError(error: Error, errorOf?: string): void {


      if ((error as any)?.handledByInterceptor) {
        if (!environment.production) {
          console.log('Skipping toast — error already handled by interceptor:', error);
        }
        return;
      }


      console.log( 'error of' ,errorOf)
      errorOf = errorOf || 'system';
      // errorOf = 'system';
      if (!environment.production) {
      console.log(error, errorOf);

    }
      if(error?.code === 403 ) {
        let errorMessage = this._translate.instant('_access_denied_');
        this.toastService.toast(errorMessage , 'error').then()
        // this.router.navigate(['/tabs/campaigns'])
        return ;
      }

    const errorMessage = ( error && error.code && ERROR_MESSAGES[errorOf][error.code.toString()]) ?
      this._translate.instant(ERROR_MESSAGES[errorOf][error.code.toString()])
      : this._translate.instant('_something_went_wrong_try_again_');
      this.toastService.toast(errorMessage, 'error').then();

  }

    routeResolverError(error): Observable<any> {
      this.handleError(error);
      this.router.navigate(['/404']).then();
      return of(error);
    }
}
